<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="[
        'Nome',
        'Tipo',
        'Data de Criação',
        $lang.Common.DataTable.Actions
      ]"
      :showNew="true"
      :showSearch="true"
      :showReload="true"
      :showTipFooter="false"
      v-on:New="onNew"
      v-on:Search="onShowSearch"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.nome ? obj.nome.toUpperCase() : ''"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="
            obj.tipo ? (obj.tipo === 1 ? 'CLIENTES' : 'NÃO CLIENTES') : ''
          "
        />
        <TableColumn
          :IsDatetime="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.dataCriacao ? obj.dataCriacao : ''"
        />
        <TableColumn
          :IsActionsButtons="true"
          :HasChange="false"
          v-on:Delete="onDelete(obj)"
          :status="obj.status"
        />
      </tr>
    </Tables>

    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="$emit('New')"
          v-b-tooltip.hover
          :title="'Clique para cadastrar'"
        >
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
    <SidebarSearch @search="onSearch" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import SegmentationRepository from '@/shared/http/repositories/configurations/campaignlist.js'
import SidebarSearch from '@/views/private/configurations/campaign/campaignlist/components/search/SidebarCampanhaLista.vue'

export default {
  name: 'OriginList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  components: {
    SidebarSearch
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        let optionFilters = ''
        if (this.filters.nome) {
          optionFilters += `nome=${this.filters.nome}&`
        }
        SegmentationRepository.Search(optionFilters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      } else {
        SegmentationRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      SegmentationRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/campaignlist/components/list/list.vue